import { Board } from '../../types/kanban';
import { Link } from 'react-router-dom';
import { formatRelativeTime } from '../../utils/dateFormat';
import Edit2Icon from '../icons/Edit2Icon';
import Trash2Icon from '../icons/Trash2Icon';

interface BoardCardProps {
  board: Board;
  onDelete: (id: number) => void;
}

export function BoardCard({ board, onDelete }: BoardCardProps) {
  const handleDelete = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.confirm(`Are you sure you want to delete "${board.name}"?`)) {
      onDelete(board.id);
    }
  };

  return (
    <div className="group bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition-all hover:shadow-lg hover:-translate-y-1 border border-gray-700">
      <div className="flex justify-between items-start mb-3">
        <h3 className="text-xl font-bold text-white">
          <Link to={`/boards/${board.id}`} className="hover:text-blue-400 transition-colors">
            {board.name}
          </Link>
        </h3>
        <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <Link
            to={`/boards/${board.id}/edit`}
            className="text-gray-400 hover:text-blue-400 transition-colors"
            title="Edit board"
          >
            <span className="w-4 h-4">
              <Edit2Icon />
            </span>
          </Link>
          <button
            onClick={handleDelete}
            className="text-gray-400 hover:text-red-400 transition-colors"
            title="Delete board"
          >
            <span className="w-4 h-4">
              <Trash2Icon />
            </span>
          </button>
        </div>
      </div>

      {board.description && (
        <p className="text-gray-400 text-sm mb-4 line-clamp-2">{board.description}</p>
      )}

      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-500">
          Last activity: {formatRelativeTime(board.date_last_activity)}
        </span>
      </div>
    </div>
  );
}
